import { YoutubeVideo, YoutubeVideoSection } from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';
import { formatDateToTimeAgo, parseDate } from '@phoenix/core/frontend/shared/util/format/dates';

import { VideoCard, VideoChannel } from './video-channel.model';

const VIDEO_THUMBNAIL_FALLBACK_IMAGE_URL = 'https://i.ytimg.com';

const mapToVideoCard = (video: YoutubeVideo): VideoCard => ({
  title: video.title || '',
  description: video.description || undefined,
  url: video.url || undefined,
  publishedAt: video.publishedAt ? formatDateToTimeAgo(parseDate(video.publishedAt)) : '',
  thumbnailUrl:
    video.thumbnail?.maxres?.url || video.thumbnail?.standard?.url || video.thumbnail?.high?.url || VIDEO_THUMBNAIL_FALLBACK_IMAGE_URL,
});

export const mapToVideoChannel = (channel: YoutubeVideoSection): VideoChannel => ({
  url: channel.url || undefined,
  videos: channel.videos.map(mapToVideoCard),
  isFallback: channel.isFallback || undefined,
});
